import clsx from 'clsx';
import React from 'react';
import type { DropZoneProps } from '@/hooks/useFileDrop/types';
import UploadIcon from '/public/icons/upload.svg';
import { cn } from '@/utils/сn';

interface DropZoneAreaProps extends DropZoneProps {
  isDragging: boolean;
  isError: boolean;
  disabled?: boolean;
  children: React.ReactNode;
  className?: string;
  uploadIcon?: React.ComponentType<React.SVGProps<SVGSVGElement>>;
}

export function DropZoneArea({
  isDragging,
  isError,
  children,
  disabled,
  className,
  uploadIcon: UploadIconComponent,
  ...dropZoneProps
}: DropZoneAreaProps) {
  const iconClsx = clsx('w-[40px] h-[40px]', {
    'text-blue-300': !isDragging || isDragging,
    'text-red-500': isError,
    'text-neutral-700': disabled,
  });

  const Icon = UploadIconComponent || UploadIcon;

  return (
    <div
      {...dropZoneProps}
      className={cn('flex flex-col items-center justify-center w-full h-full rounded-lg', className, {
        'bg-blue-50': isDragging,
        'bg-gray-200 cursor-not-allowed border-dashed border-neutral-400': disabled,
        'border-dashed border-neutral-400 border bg-white': !isDragging,
        'border-blue-150 border': isDragging,
        'transition-colors duration-200 ease-in': isDragging,
        'border-red-500 border bg-[#F23F4414]': isError,
      })}
    >
      <Icon className={iconClsx} />
      {children}
    </div>
  );
}